import user from './user'
import login from './login'
import pay from './pay'
import course from './course'
import serial from './serial'
import { fetchLoginInfo, containCourse } from '../actions/login'
import { isMobile } from '../core/utils'
import { BIND_PAGE, LOGIN_PAGE } from '../config'
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
* Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/* eslint-disable global-require */

// 需要立即跳转登录页的路由表,(有的页面不需要立刻跳登录页)
const pages = [
  '/user',
]

// The top-level (parent) route
const routes = {

  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '/',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: '/tag/:id',
      load: () => import(/* webpackChunkName: 'tag' */ './tag'),
    },
    // {
    //   path: '/user/mycourse',
    //   load: () => import(/* webpackChunkName: 'mycourse' */ './mycourse'),
    // },
    {
      path: '/user',
      children: user,
    },
    {
      path: '/pay',
      children: pay,
    },
    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    {
      path: '/search/:wd',
      load: () => import(/* webpackChunkName: 'search' */ './search'),
    },
    {
      path: '/login',
      children: login,
    },
    {
      path: '/download',
      load: () => import(/* webpackChunkName: 'download' */ './download'),
    },
    {
      path: '/serial',
      children: serial,
    },
    {
      path: '/course',
      children: course,
    },
    {
      path: '*',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next, store, query, pathName, urlGenerator }) {
    // Execute each child route until one of them return the result
    await store.dispatch(fetchLoginInfo())
    const logininfo = store.getState().login.logininfo
    const { login: isLogin, phone } = logininfo
    const { loginBack } = query

    // 登陆成功之后跳转
    if (isLogin && !isMobile(phone) &&
      loginBack === 'true') {
      const result = await store.dispatch(containCourse())

      if (!result) {
        return { // 重定向到绑定页
          redirect: `${BIND_PAGE}${encodeURIComponent(urlGenerator(pathName, {
            loginBack: false,
          }))}`,
        }
      }
    }
    // 如果pathName是需要登录的路由：即pathName开头匹配到了任一需要登陆的路由地址in pages
    if (!isLogin && pages.find(p => pathName.startsWith(p))) {
      return { // 重定向到登陆页
        redirect: `${LOGIN_PAGE}${encodeURIComponent(urlGenerator(pathName, {
          loginBack: true,
        }))}`,
      }
    }

    const route = await next();
    // Provide default values for title, description etc.
    route.title = `${route.title || 'Untitled Page'} - 为你精选好课`;
    route.keywords = route.keywords || '有道,有道精品课,网易,网易有道,youdao,网易公开课,作业,学习,网课,教育,课堂,课程,名师,听课,辅导,英语,数学,语文,大学,初中,高中,小学,考研,学英语,学习辅导,学习软件,空中课堂,直播课,学英语软件,背单词,口语,英语音标,四级,六级,四六级,TED英语演讲,英语单词,英语语法,英语四级,英语4级,托福,雅思,逻辑英语,英语作文,英语讲课,英语课程,大学生mooc,大学英语四级,大学资源网,考研核心词速记,考神有道,考试点考研,英语六级词汇,英语四级作文,英语直播课,英语笔译,英语网课,英语考试,英语考试题,英语语法时态介词,英语语法软件,英语课,英语课文,英语题,雅思课程,零基础英语';
    route.description = route.description || '有道精品课是网易集团旗下的知名教育培训品牌，覆盖【青少年素养】、【高中规划】等全年龄段课程。有道优秀的教师团队，为孩子量身定制学习方案，让孩子习得高效学习方法，改善薄弱方向，取得学业进步。';

    return route;
  },

};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js